import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Loader } from "lucide-react";
import { GET_REVENUE } from "../../graphql/queries/revenue";

const getStartOfMonth = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
};

const getEndOfToday = () => {
  return new Date();
};

const formatDateForBackend = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const RevenueChart = () => {
  const [startDate, setStartDate] = useState(getStartOfMonth());
  const [endDate, setEndDate] = useState(getEndOfToday());

  const { loading, error, data } = useQuery(GET_REVENUE, {
    variables: {
      startDate: formatDateForBackend(startDate),
      endDate: formatDateForBackend(endDate),
    },
  });

  if (loading) return <Loader sizeClass={"size--medium"} />;
  if (error) {
    return <div className="">Something went wrong</div>;
  }

  const revenueData = data?.revenue || [];

  return (
    <div>
      <div className="date-pickers">
        <div className="date-pickers__option">
          <span>Start Date</span>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            maxDate={endDate}
          />
        </div>
        <div className="date-pickers__option">
          <span>End Date</span>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate}
            maxDate={new Date()}
          />
        </div>
      </div>

      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={revenueData}>
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="revenue" fill="#f6d13d" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RevenueChart;
